import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  TravelCompany,
  TravelCompanySort
} from '../../lib/types/models/travel-company/travel-company'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTravelCompanies(
  input: PaginationRequest<null, string, Version, TravelCompanySort> = {}
) {
  if (!input.sort) input.sort = { name: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.travelCompanies.getAll.url, null), input))
    .get<PaginationResponse<TravelCompany>>()
}
